import { CandidateStageType } from '@/types/api';
import { cleanStringSpaces } from '@/utils/global';
import * as Styles from './CandidateNotesSidebar.styles';

export type CandidateNotesSidebarComponentProps = {
  candidateStages: CandidateStageType[];
  onOpenModal: (stageId: string) => void;
};

const CandidateNotesSidebarComponent = function ({
  candidateStages,
  onOpenModal,
  ...props
}: CandidateNotesSidebarComponentProps): JSX.Element {
  const onClickTopic = (id: string): void => {
    const parent = document.getElementById('page-content');
    const elementToScroll = document.getElementById(id)?.offsetTop ?? 0;
    parent?.scroll({
      top: elementToScroll - 50,
      behavior: 'smooth',
    });
  };
  return (
    <Styles.NotesSidebar data-testid="candidate-notes-sidebar" {...props}>
      <Styles.SidebarSubtitle>Jump to</Styles.SidebarSubtitle>
      <Styles.SidebarTopics>
        {candidateStages.map((stage) => {
          return (
            <div key={stage.id} data-testid={`candidate-stage-${cleanStringSpaces(stage.name)}`}>
              <Styles.Stage>{stage.name}</Styles.Stage>
              <ul>
                {stage.topics.map((topic) => {
                  const formattedLink = cleanStringSpaces(topic.name);
                  return (
                    <li
                      key={topic.id}
                      data-testid={`candidate-topic-${cleanStringSpaces(topic.name)}`}
                    >
                      <Styles.Topic
                        data-testid={`candidate-stage-${cleanStringSpaces(stage.name)}-option`}
                        onClick={() => onClickTopic(formattedLink)}
                      >
                        {topic.name}
                      </Styles.Topic>
                    </li>
                  );
                })}
              </ul>
              <Styles.NewTopicButton
                data-testid={`add-${cleanStringSpaces(stage.name)}-topic-button`}
                onClick={() => onOpenModal(stage.id)}
                type="button"
              >
                + New Topic
              </Styles.NewTopicButton>
            </div>
          );
        })}
        <Styles.DownArrow />
      </Styles.SidebarTopics>
    </Styles.NotesSidebar>
  );
};

export default CandidateNotesSidebarComponent;
